import {useSuspenseQuery} from '@github-ui/react-query'

import {
  fetchMarkdownEditHistoryMetadata,
  markdownEditHistoryMetadataQueryKey,
} from './fetch-markdown-edit-history-metadata'

// This hook is used as a stopgap in PRs where relay components are used in a non-relay environment
export function useMarkdownEditHistoryViewerQuery({id}: {id: string}) {
  const {data} = useSuspenseQuery({
    queryKey: markdownEditHistoryMetadataQueryKey(id),
    queryFn: ({signal}) => fetchMarkdownEditHistoryMetadata(id, signal),
  })

  return data
}
